import { render, staticRenderFns } from "./NavCircuitExercises.vue?vue&type=template&id=04c4705a"
import script from "./NavCircuitExercises.vue?vue&type=script&lang=js"
export * from "./NavCircuitExercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports